



























import { Vue, Component, Prop, Emit } from "vue-property-decorator";

import Debounce from "@/core/decorators/Debounce";

@Component
export default class InputAutoComplete extends Vue {
  @Prop()
  label!: string;

  @Prop()
  placeholder!: string;

  @Prop()
  suggestions!: string[];

  @Prop()
  loading!: boolean;

  @Debounce(500)
  @Emit()
  onType(event: Event) {
    const target = event.target as HTMLInputElement;
    return target.value;
  }

  @Emit()
  onOptionSelected(event: Event) {
    const target = event.target as HTMLInputElement;
    target.blur();
    return { search: target.value };
  }
}
